import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useToast, ConfirmDialog, Alert, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useRemoveExternalSharingInvite } from '../../hooks/useRemoveExternalSharingInvite';
export function RemoveExternalSharingInviteDialog(props) {
    const { id, email, onClose } = props;
    const { addToast } = useToast();
    const { removeExternalSharingInvite, loading, error } = useRemoveExternalSharingInvite();
    const handleConfirm = () => {
        if (id !== undefined) {
            removeExternalSharingInvite(id).then(() => {
                addToast({ title: t `Successfully removed access`, appearance: 'success' });
                onClose();
            });
        }
    };
    return (<ConfirmDialog appearance="danger" cancel={t `Cancel`} confirm={t `Remove`} icon={<Falcon icon="user"/>} title={t `Remove access`} loading={loading} onCancel={onClose} onClose={onClose} onConfirm={handleConfirm} size="sm">
      <Typography>
        <Trans>Are you sure you want to remove {email}&apos;s access to the document?</Trans>
      </Typography>
      {error && (<Alert appearance="danger" message={t({
                message: 'Something went wrong, please try again later.',
                comment: 'error alert when failed to remove external sharing invite - message',
            })}/>)}
    </ConfirmDialog>);
}
